import { render, staticRenderFns } from "./TransferByDocument.vue?vue&type=template&id=6f453f1c"
import script from "./TransferByDocument.vue?vue&type=script&lang=js"
export * from "./TransferByDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports